// Aggancio condiviso alla chat (widget Chatwoot montato sitewide, ADR 0019).
// Usato da tutte le CTA contatto per promuovere la chat come canale primario.
//
// La chat è "sempre attiva": il bot di triage accoglie e smista a qualsiasi ora;
// un tecnico segue la conversazione negli orari di assistenza (Lun–Ven 9–18).
import type { MouseEvent } from 'react'
import { trackEvent } from '@/lib/analytics'

// Etichette condivise — un solo posto per il tono del canale chat.
export const CHAT_LABEL = 'Chatta con noi'
export const CHAT_TAGLINE = 'Sempre attiva · l’assistente risponde subito'

// Fallback se il widget non è caricato (errore script, niente JS): apre WhatsApp.
export const CHAT_WA_FALLBACK = 'https://api.whatsapp.com/send?phone=3905442330899'

type ChatwootToggle = { toggle: (state?: 'open' | 'close') => void }

// L'evento GA4 chat_aperta parte UNA volta sola, sul chatwoot:opened (vedi
// ChatwootWidget): questo flag dice al listener se l'apertura arriva da una CTA
// del sito o dalla nuvoletta, senza doppi conteggi quando la CTA fa toggle().
let openViaCta = false
export function consumeChatOpenSource(): 'cta' | 'bubble' {
  const fonte = openViaCta ? 'cta' : 'bubble'
  openViaCta = false
  return fonte
}

// Apre il widget Chatwoot se disponibile; altrimenti lascia procedere l'href (WhatsApp).
export function openChat(e: MouseEvent<HTMLAnchorElement>) {
  const cw = (window as unknown as { $chatwoot?: ChatwootToggle }).$chatwoot
  if (cw) {
    e.preventDefault()
    openViaCta = true
    cw.toggle('open')
  } else {
    // Widget non caricato → il click prosegue verso WhatsApp: contatto comunque
    // avvenuto, lo contiamo con la sua fonte per non perdere il canale dal quadro.
    trackEvent('chat_aperta', { fonte: 'cta_whatsapp_fallback' })
  }
}
